import React, { useState } from 'react';
import '../styles/about.css';
import { FaGraduationCap, FaBrain } from 'react-icons/fa';

import perfil from "../assets/images/about/perfil.jpg";

const About = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="about-section-content">

          {/* Foto do psicólogo */}
          <div className="about-carousel">
            <div className="carousel-slide">
              <img src={perfil} alt="Foto de perfil" className="perfil-image" />
            </div>
          </div>

          {/* Texto + Cards empilhados */}
          <div className="about-text-and-cards">
            <div className="about-text">
              <h2 className="about-title">Sobre mim</h2>
              <p className="about-description" style={{ textAlign: "justify" }}>
                Meu nome é Marcelo Martins, sou psicólogo formado pela FMU em São Paulo desde 2014. A psicologia era um sonho distante que, quanto mais eu conhecia, mais me encantava, especialmente pelo atendimento clínico. Minha abordagem é a Psicanálise, e também atuo como Psicólogo de Emergência, auxiliando em situações de crise e alta demanda emocional. Além disso, realizo supervisões clínicas para casos específicos, sempre buscando aprimorar um olhar clínico personalizado para cada paciente.
                Atendo tanto presencialmente quanto online, sempre considerando as necessidades de cada paciente. Sempre que possível, recomendo o atendimento presencial ou um formato híbrido, com pelo menos uma sessão presencial por mês.
                Trabalho com diversas demandas, atendendo adultos e casais, tanto em momentos de crise quanto para acompanhamento a longo prazo. Acredito em um atendimento humano e personalizado, adaptado às necessidades específicas de cada indivíduo. Tenho experiência com pacientes que me acompanham há anos, ajustando a terapia conforme cada fase da vida, assim como com aqueles que buscam apoio pontual e retornam quando novas questões surgem.
                Minha abordagem baseia-se na Psicanálise, e recomendo atendimentos semanais. No entanto, a frequência pode ser ajustada conforme a necessidade de cada paciente. Atualmente, atendo apenas particular, mas há possibilidade de reembolso a depender do convênio.
              </p>
            </div>

            {/* Cards abaixo do texto */}
            {/* <div className="cards-container">
              <div className="card">
              <FaGraduationCap className="card-icon" />
              <h3 className="card-title">Certificados e Formação</h3>
                <p className="card-description-about">
                  Psicólogo licenciado<br />
                  CRP 06/123896
                </p>
              </div>

              <div className="card">
              <FaBrain className="card-icon" />
              <h3 className="card-title">Abordagem Psicanalítica</h3>
                <p className="card-description-about">
                  A psicanálise é um processo terapêutico que busca ajudar você a compreender as questões inconscientes que influenciam seus pensamentos e comportamentos. Com base na escuta e na interpretação, podemos juntos buscar soluções para suas dificuldades emocionais.
                </p>
              </div>
            </div> */}
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
